/**
 * 模块: Keyword Share Columns
 * 职责: 关键词表格份额列定义（点击份额、转化份额）
 * 限制: <280行
 */

import React from 'react';
import { Tooltip } from 'antd';
import type { ColumnType } from 'antd/es/table';
import { renderPercent, renderGrowthRate, metricSorter } from './columnUtils';

/**
 * 份额相关列（点击份额、转化份额及其CAGR）
 */
export const shareColumns: ColumnType<any>[] = [
  {
    title: <Tooltip title="所有周期Top3点击份额的平均值">平均点击份额</Tooltip>,
    dataIndex: ['metrics', 'avg_click_share'],
    key: 'avg_click_share',
    align: 'center',
    render: (value: number) => renderPercent(value, { excellent: 60, good: 40, moderate: 20 }),
    sorter: (a: any, b: any) => metricSorter(a, b, 'avg_click_share'),
  },
  {
    title: <Tooltip title="最新周期的Top3点击份额">最新点击份额</Tooltip>,
    dataIndex: ['metrics', 'latest_click_share'],
    key: 'latest_click_share',
    align: 'center',
    render: (value: number) => renderPercent(value, { excellent: 60, good: 40, moderate: 20 }),
    sorter: (a: any, b: any) => metricSorter(a, b, 'latest_click_share'),
  },
  {
    title: <Tooltip title="点击份额增长率 - 正值表示份额增长">点击份额CAGR(%)</Tooltip>,
    dataIndex: ['metrics', 'click_share_cagr'],
    key: 'click_share_cagr',
    align: 'center',
    render: renderGrowthRate,
    sorter: (a: any, b: any) => metricSorter(a, b, 'click_share_cagr'),
  },
  {
    title: <Tooltip title="所有周期Top3转化份额的平均值">平均转化份额</Tooltip>,
    dataIndex: ['metrics', 'avg_conversion_share'],
    key: 'avg_conversion_share',
    align: 'center',
    render: (value: number) => renderPercent(value, { excellent: 60, good: 40, moderate: 20 }),
    sorter: (a: any, b: any) => metricSorter(a, b, 'avg_conversion_share'),
  },
  {
    title: <Tooltip title="最新周期的Top3转化份额">最新转化份额</Tooltip>,
    dataIndex: ['metrics', 'latest_conversion_share'],
    key: 'latest_conversion_share',
    align: 'center',
    render: (value: number) => renderPercent(value, { excellent: 60, good: 40, moderate: 20 }),
    sorter: (a: any, b: any) => metricSorter(a, b, 'latest_conversion_share'),
  },
  {
    title: <Tooltip title="转化份额增长率 - 正值表示份额增长">转化份额CAGR(%)</Tooltip>,
    dataIndex: ['metrics', 'conversion_share_cagr'],
    key: 'conversion_share_cagr',
    align: 'center',
    render: renderGrowthRate,
    sorter: (a: any, b: any) => metricSorter(a, b, 'conversion_share_cagr'),
  },
];

